
import { systemLogService } from '../../services';
import { request, success, failure, getApiErrorMessage } from '../../helpers';
import { systemLogsTypes } from '../types';

const getSystemLogs = (filterParams) => {
    return dispatch => {
        dispatch(request(systemLogsTypes.GET_SYSTEM_LOGS_REQUEST));

        systemLogService.getSystemLogs(filterParams)
            .then(
                data => {
                    if (data && data.hasOwnProperty('message')) {
                        const message = getApiErrorMessage(data);
                        dispatch(failure(systemLogsTypes.GET_SYSTEM_LOGS_FAILURE, message));
                        return;
                    }

                    dispatch(success(systemLogsTypes.GET_SYSTEM_LOGS_SUCCESS, { payload: data }));
                },
                (errorPayload) => {
                    const message = getApiErrorMessage(errorPayload);
                    dispatch(failure(systemLogsTypes.GET_SYSTEM_LOGS_FAILURE, message));
                }
            );
    };
}

export const systemLogsActions = {
    getSystemLogs
};
